import React, { useState } from 'react';
import { SvgXml } from 'react-native-svg';

import { Text } from 'app/shopify/theme';
import { Column, Row } from 'app/shopify/components/layout';

import { ToggleButton, ToggleButtonGroup } from './ToggleButton';

const HEART_ICON_XML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.5 3C15.1069 3 13.7708 3.55357 12.7854 4.53895C12.5075 4.81688 12.2469 5.11161 12.0049 5.42188L11.6562 4.98828C11.4521 4.75501 11.2342 4.53414 11.0039 4.32617C10.03 3.45814 8.77045 2.99163 7.46582 3.01758C6.1612 3.04352 4.92117 3.55996 3.98242 4.46582C3.04368 5.37167 2.4828 6.59249 2.41309 7.89551C2.34339 9.19852 2.76995 10.4715 3.6084 11.4727L11.2959 20.6084L11.3105 20.624C11.3974 20.7108 11.5006 20.7798 11.6142 20.8268C11.7278 20.8739 11.8495 20.898 11.9725 20.898C12.0954 20.898 12.2171 20.8739 12.3307 20.8268C12.4444 20.7798 12.5476 20.7108 12.6345 20.624L20.3604 11.4746C21.1971 10.4732 21.6228 9.20091 21.5533 7.89893C21.4837 6.59695 20.9238 5.37673 19.9863 4.4707C19.0488 3.56467 17.8107 3.04774 16.5078 3.02051L16.5 3Z" fill="currentColor"/>
</svg>`;
const USER_ICON_XML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 4.25C10.7586 4.25 9.75 5.25861 9.75 6.5C9.75 7.74139 10.7586 8.75 12 8.75C13.2414 8.75 14.25 7.74139 14.25 6.5C14.25 5.25861 13.2414 4.25 12 4.25ZM8.25 6.5C8.25 4.43018 9.93018 2.75 12 2.75C14.0698 2.75 15.75 4.43018 15.75 6.5C15.75 8.56982 14.0698 10.25 12 10.25C9.93018 10.25 8.25 8.56982 8.25 6.5Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 13.75C9.60279 13.75 7.56182 15.3456 6.88776 17.5712C6.76771 17.9676 6.34917 18.1914 5.95275 18.0714C5.55634 17.9513 5.33253 17.5328 5.45257 17.1364C6.31519 14.2876 8.93074 12.25 12 12.25C15.0693 12.25 17.6848 14.2876 18.5474 17.1364C18.6675 17.5328 18.4437 17.9513 18.0472 18.0714C17.6508 18.1914 17.2323 17.9676 17.1122 17.5712C16.4382 15.3456 14.3972 13.75 12 13.75Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z" fill="currentColor"/>
</svg>`;
const CAMERA_ICON_XML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.1549 4.29398C10.3575 3.83789 10.81 3.54395 11.309 3.54395H12.6909C13.1899 3.54395 13.6424 3.83789 13.845 4.29398L14.5593 5.90105C14.5844 5.95747 14.6404 5.99384 14.7022 5.99384H17.2939C18.8111 5.99384 20.041 7.22371 20.041 8.74091V16.7292C20.041 18.2464 18.8111 19.4763 17.2939 19.4763H6.70611C5.1889 19.4763 3.95903 18.2464 3.95903 16.7292V8.74091C3.95903 7.2237 5.1889 5.99384 6.70611 5.99384H9.29781C9.35952 5.99384 9.41548 5.95747 9.44055 5.90105L10.1549 4.29398ZM11.309 5.04395C11.4035 5.04395 11.4892 5.09962 11.5276 5.18595L12.2419 6.79302C12.5079 7.39159 13.101 7.77686 13.7573 7.77686H17.2939C17.983 7.77686 18.5416 8.33551 18.5416 9.0246V16.1828C18.5416 16.872 17.983 17.4306 17.2939 17.4306H6.70611C6.017 17.4306 5.45835 16.872 5.45835 16.1828V9.0246C5.45835 8.3355 6.017 7.77685 6.70611 7.77685H10.2427C10.899 7.77685 11.492 7.39159 11.7581 6.79302L12.4724 5.18595C12.5107 5.09962 12.5965 5.04395 12.6909 5.04395H11.309Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 10.6208C10.6122 10.6208 9.48714 11.7458 9.48714 13.1337C9.48714 14.5215 10.6122 15.6466 12 15.6466C13.3878 15.6466 14.5129 14.5215 14.5129 13.1337C14.5129 11.7458 13.3878 10.6208 12 10.6208ZM7.98779 13.1337C7.98779 10.9177 9.7844 9.12109 12.0003 9.12109C14.2162 9.12109 16.0129 10.9177 16.0129 13.1337C16.0129 15.3496 14.2162 17.1462 12.0003 17.1462C9.7844 17.1462 7.98779 15.3496 7.98779 13.1337Z" fill="currentColor"/>
</svg>`;

export function ToggleButtonShowcase() {
  const [isSelected, setIsSelected] = useState(false);
  const [selectedGroupIndex, setSelectedGroupIndex] = useState(0);
  const [selectedIconGroupIndex, setSelectedIconGroupIndex] = useState(0);

  return (
    <Column gap="spacing.general.x4" padding="spacing.general.x4">
      <Text variant="bodySmall" color="text.secondary">
        Toggle Button - etats Figma selected/not-selected en enabled, hover et pressed.
      </Text>

      <Row gap="spacing.general.x3">
        <ToggleButton
          label={isSelected ? 'Selected' : 'Not selected'}
          selected={isSelected}
          onPress={() => setIsSelected((prev) => !prev)}
        />
      </Row>

      <Column gap="spacing.general.x2">
        <Text variant="bodySmall" color="text.secondary">
          Toggle Button Group - default et icon only.
        </Text>

        <ToggleButtonGroup
          type="default"
          selectedIndex={selectedGroupIndex}
          onChange={setSelectedGroupIndex}
          options={[
            { key: 'all', label: 'Click me' },
            { key: 'news', label: 'Click me' },
            { key: 'events', label: 'Click me' },
          ]}
        />

        <ToggleButtonGroup
          type="iconOnly"
          selectedIndex={selectedIconGroupIndex}
          onChange={setSelectedIconGroupIndex}
          options={[
            {
              key: 'fav',
              icon: <SvgXml xml={HEART_ICON_XML} width={24} height={24} color="currentColor" />,
            },
            {
              key: 'profile',
              icon: <SvgXml xml={USER_ICON_XML} width={24} height={24} color="currentColor" />,
            },
            {
              key: 'camera',
              icon: <SvgXml xml={CAMERA_ICON_XML} width={24} height={24} color="currentColor" />,
            },
          ]}
        />
      </Column>

      <Row gap="spacing.general.x3">
        <ToggleButton label="Click me" type="ghost" />
        <ToggleButton label="Click me" type="ghost" state="hover" />
        <ToggleButton label="Click me" type="ghost" state="pressed" />
      </Row>

      <Row gap="spacing.general.x3">
        <ToggleButton label="Click me" selected />
        <ToggleButton label="Click me" selected state="hover" />
        <ToggleButton label="Click me" selected state="pressed" />
      </Row>

      <Row gap="spacing.general.x3">
        <ToggleButton label="Click me" type="outline" />
        <ToggleButton label="Click me" type="outline" state="hover" />
        <ToggleButton label="Click me" type="outline" state="pressed" />
      </Row>
    </Column>
  );
}
